

export default {
  props: {
    label: {
      type: String,
      default: "Open notificaties",
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    showIndicator: {
      type: Boolean,
      default: false,
    }
  }, 
  data () {
    return {
      isLoginEnabled: this.$config.featureLoginEnabled,
    }
  },
  computed: {
    isLoggedIn () {
      return this.$auth.loggedIn
    },
  },
  methods: {
    onClick () {
      this.$emit('click')
    },
  }
}

